import { mapActions } from 'vuex'
import { findIndex } from 'lodash'

import SvgLoader from '../svg-loader/index.vue'
import BotImage from '../bot-image/index.vue'

export default {
  data () {
    return {
      allBots: []
    }
  },
  components: {
    BotImage,
    SvgLoader
  },
  mounted () {
    this.setAllBots()
  },
  methods: {
    ...mapActions([
      'actionGetLocalStorageAllBots',
      'actionSetLocalStorageAllBots'
    ]),
    async setAllBots () {
      this.allBots = await this.actionGetLocalStorageAllBots()
    },
    removeBot (bot) {
      const index = findIndex(this.allBots, { botId: bot.botId })

      if (index > -1) {
        this.allBots.splice(index, 1)
        this.actionSetLocalStorageAllBots(this.allBots)
      }

      this.$emit('updated')
    }
  }
}
